export const ZOOM_ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'esaas-zoom-access-token';
export const ZOOM_REFRESH_TOKEN_LOCAL_STORAGE_KEY = 'esaas-zoom-refresh-token';
